// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Chips__container-ea7168 {
  height: 65px;
  max-height: 0;
}

.Chips__has-content-b761ee {
  max-height: 65px;
}

@keyframes Chips__visible-b5513b {
  from {
    max-height: 0;
  }
  to {
    max-height: 65px;
  }
}
@keyframes Chips__no_visible-fb40ed {
  from {
    max-height: 65px;
  }
  to {
    max-height: 0;
  }
}
.Chips__chips-edf7c4 {
  display: flex;
  flex-direction: row;
  overflow: auto;
  padding-bottom: 16px;
  margin: 0 16px 4px;
}

.Chips__chips-edf7c4::-webkit-scrollbar {
  width: 12px;
  height: 3px;
}

.Chips__enterActive-af2e28 {
  animation-name: Chips__visible-b5513b;
  animation-timing-function: ease-out;
  animation-duration: 0.3s;
}

.Chips__exitActive-ba1f9b {
  animation-name: Chips__no_visible-fb40ed;
  animation-timing-function: ease-out;
  animation-duration: 0.3s;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Chips/Chips.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;EACA;IACE,gBAAA;EACF;AACF;AAEA;EACE;IACE,gBAAA;EAAF;EAEA;IACE,aAAA;EAAF;AACF;AAGA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;AADF;;AAIA;EACE,WAAA;EACA,WAAA;AADF;;AAIA;EACE,qCAAA;EACA,mCAAA;EACA,wBAAA;AADF;;AAIA;EACE,wCAAA;EACA,mCAAA;EACA,wBAAA;AADF","sourcesContent":[".container {\n  height: 65px;\n  max-height: 0;\n}\n\n.has-content {\n  max-height: 65px;\n}\n\n@keyframes visible {\n  from {\n    max-height: 0;\n  }\n  to {\n    max-height: 65px;\n  }\n}\n\n@keyframes no_visible {\n  from {\n    max-height: 65px;\n  }\n  to {\n    max-height: 0;\n  }\n}\n\n.chips {\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n  padding-bottom: 16px;\n  margin: 0 16px 4px;\n}\n\n.chips::-webkit-scrollbar {\n  width: 12px;\n  height: 3px;\n}\n\n.enterActive {\n  animation-name: visible;\n  animation-timing-function: ease-out;\n  animation-duration: 0.3s;\n}\n\n.exitActive {\n  animation-name: no_visible;\n  animation-timing-function: ease-out;\n  animation-duration: 0.3s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Chips__container-ea7168`,
	"has-content": `Chips__has-content-b761ee`,
	"hasContent": `Chips__has-content-b761ee`,
	"chips": `Chips__chips-edf7c4`,
	"enterActive": `Chips__enterActive-af2e28`,
	"visible": `Chips__visible-b5513b`,
	"exitActive": `Chips__exitActive-ba1f9b`,
	"no_visible": `Chips__no_visible-fb40ed`,
	"noVisible": `Chips__no_visible-fb40ed`
};
module.exports = ___CSS_LOADER_EXPORT___;
